import React, { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import { managementOperationAPI } from "../../../../api/managementOperationAPI";
import PickupRequest from '../../../../assets/images/PickupRequest.png';
import PickupPerformanceChart from '../../../chart/managementOperationChart/pickupPerformanceChart/pickupPerformanceChart';
import "./pickupRequestModal.css";
import Calendar from "../../../datepicker/calendar";
import AllPcode from "../../../allPcode";
import usePcode from "../../../../common/hooks/usePcode";


export default function PickupRequestModal() {

    const [newData, setNewData] = useState([]);
    const [monthYr, setMonthYr] = useState(new Date());
    const [isFetching, setIsFetching] = useState(false);
    const [showChart, setShowChart] = useState(false);
    const { loggedPcode } = usePcode();
    const [selectedPcode, setSelectedPcode] = useState(loggedPcode);

    useEffect(() => {
        const handleShowChart = () => {
            setShowChart(true);
        };

        const modalElement = document.getElementById("PickupRequest");
        if (modalElement) {
            modalElement.addEventListener("shown.bs.modal", handleShowChart);
        }

        return () => {
            if (modalElement) {
                modalElement.removeEventListener("shown.bs.modal", handleShowChart);
            }
        };
    }, []);

    const filterdata = (pendingData, completeData) => {
        const chartData = [["Route Name", "Pending", "Completed"]];
        const routeMap = {};

        // Populate routeMap with route names
        pendingData.forEach((pending) => {
            if (!routeMap[pending.routeName]) {
                routeMap[pending.routeName] = { pending: pending.pending, completed: null };
            } else {
                routeMap[pending.routeName].pending = pending.pending;
            }
        });

        completeData.forEach((compl) => {
            if (!routeMap[compl.routeName]) {
                routeMap[compl.routeName] = { pending: null, completed: compl.completed };
            } else {
                routeMap[compl.routeName].completed = compl.completed;
            }
        });

        // Convert routeMap to chartData
        Object.keys(routeMap).forEach(routeName => {
            const { pending, completed } = routeMap[routeName];
            chartData.push([routeName, pending || 0, completed || 0]);
        });

        return chartData;
    }

    const handleData = (selectedPcode, monthYr) => {
        if (!monthYr) { toast.warn("Please select month and year"); return; }
        const month = monthYr.getMonth() + 1;
        const year = monthYr.getFullYear();
        setIsFetching(true);
        managementOperationAPI.getpickupPerformance(month, year, selectedPcode).then((data) => {
            setNewData(filterdata(data.pending, data.completed));
            setIsFetching(false);
        }).catch((e) => {
            setIsFetching(false);
            toast.error(e.message);
        });
    }

    useEffect(() => {
        handleData(selectedPcode, monthYr);

    }, [selectedPcode, monthYr]);

    const handleDatePicker = (date) => {
        setMonthYr(date);
    }

    return (
        <>
            <a type="button" className='border border-0 rounded rounded-5' data-bs-toggle="modal" data-bs-target="#PickupRequest">
                <img src={PickupRequest} className="card-img-top rounded rounded-5" alt="PickupRequest" />
            </a>
            <div className="modal fade" id="PickupRequest" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-sm">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Pickup Request and Completed</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body w-100 h-100 bg-light">
                            <div className="row">
                                <div className="col-0 col-sm-0 col-md-0 col-lg-8 col-xl-8 col-xxl-8">
                                    <div className="input-group input-group-sm">
                                        <AllPcode setSelectedPcode={setSelectedPcode} loggedPcode={loggedPcode} />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4">
                                    <div className="input-group input-group-sm">
                                        <Calendar onChange={handleDatePicker} />
                                    </div>
                                </div>
                                {
                                    showChart ? (newData.length > 0 ? (
                                        <PickupPerformanceChart data={newData} loading={isFetching} />
                                    ) : (
                                        <h3>No Data Available</h3>
                                    )) : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}